<script lang="ts" setup>
// Email choices live in the notifications card (per-category matrix). The legacy marketing and email flags are
// kept in the form state only so PUT /me/preferences sends them back unchanged.
import { reactive, ref, watch } from 'vue'
import type { UserPreferencesDto } from '@roadfootage/api-client'
import { useUserStore } from '../../stores/user/user.store'

const emit = defineEmits(['save'])
const userStore = useUserStore()
const savingPreferences = ref(false)

const preferencesForm: UserPreferencesDto = reactive(
  userStore.userPreferences ?? {
    agreesToMarketing: false,
    enableEmailNotifications: false,
    enableAdvertisements: false
  }
)

async function onSubmit() {
  savingPreferences.value = true
  try {
    await userStore.savePreferences(preferencesForm)
  } catch (e) {
    console.error(e)
    return
  } finally {
    savingPreferences.value = false
  }
  emit('save')
}

watch(
  () => userStore.userPreferences,
  (preferences) => {
    if (!preferences) return
    preferencesForm.agreesToMarketing = preferences.agreesToMarketing
    preferencesForm.enableEmailNotifications = preferences.enableEmailNotifications
    preferencesForm.enableAdvertisements = preferences.enableAdvertisements
  }
)
</script>
<template>
  <q-form @submit="onSubmit" class="q-gutter-md">
    <div>
      <q-checkbox
        v-model="preferencesForm.enableAdvertisements"
        label="Support Road Footage by showing ads when using the platform."
      />
    </div>
    <div>
      <q-btn
        label="Save"
        type="submit"
        color="primary"
        :disable="savingPreferences"
        :loading="savingPreferences"
      />
    </div>
  </q-form>
</template>
